import * as React from "react";
import styled from "styled-components";
import { colorFunctionalGray50, colorMiscGray90 } from "@rhumbix/rmbx_design_system_design_tokens";
const StyledLabelWrapper = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 100%;
    padding-bottom: 16px;
`;
const StyledLabel = styled.span `
    color: ${colorMiscGray90};
    display: inline-block;
    font-family: Roboto;
    font-weight: 700;
`;
const RequiredLabel = styled.span `
    color: ${colorFunctionalGray50};
    font-family: Roboto;
    font-size: 10px;
    padding-left: 4px;
`;
const Label = ({ children, isRequired = false, ...props }) => (React.createElement(StyledLabelWrapper, null,
    React.createElement(StyledLabel, { ...props }, children),
    isRequired && React.createElement(RequiredLabel, null, "REQUIRED")));
export default Label;
